import React from "react";

export default function Button({
  type,
  className,
  text,
  startIcon,
  onClick,
  ...others
}) {
  return (
    <button
      type={type || "button"}
      className={className}
      onClick={onClick}
      {...others}
    >
      {startIcon && startIcon}
      {text}
    </button>
  );
}
